import { render, staticRenderFns } from "./PackagesInput.vue?vue&type=template&id=02946206&scoped=true"
import script from "./PackagesInput.vue?vue&type=script&lang=ts"
export * from "./PackagesInput.vue?vue&type=script&lang=ts"
import style0 from "./PackagesInput.vue?vue&type=style&index=0&id=02946206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02946206",
  null
  
)

export default component.exports